import {Utilities} from '@shared/utilities/utilities.model';

export enum CommodityTypeId {
	
	// Officina
	MECHANIC = 1,
	
	// Carrozeria
	CARBODY = 2,
	
	// Cristalli
	CARGLASS = 3,
	
	// Gommista
	TIER = 4,

	// Concessionario
	CAR_DEALER = 5,

	// Allesitmenti speciali
	SPECIAL_EQUIPMENT = 6,

	// Centro Pool
	POOL_CENTER = 7,

	// Vendita Usato
	USED_SALE = 8,

	// Deposito
	DEPOT = 9,

	// Soccorsi
	RESCUE = 10,

	// Trasportatore
	TRANSPORTER = 11,

	// Servizi
	SERVICES = 12,

	// Accessori
	ACCESSORIES = 13,

	// Ricambista
	DEALER = 14,

	// Rettifica
	RECTIFICATION = 15,

	// Centro di consegna
	DELIVERY_CENTER = 17,

	// Riparazioni Grandine
	HAIL_REPAIRS = 20,
}

export class CommodityModel {
	
	// rappresenta "Tutti i centri", nel menù in alto a destra
	// inutile e dannosa
	// variabile inutile, questa cosa andava gestita soltanto nell'HTML di select-center.component
	// la prima commodity viene filtrata ovunque perché non serve!
	static allCentersID = -101010101;

	id: string;
	ald_commodity_id: number;
	ald_supplier_id: number;
	ald_supplier_code: number;
	ald_parent_id: number;

	// id che rappresenta un raggruppamento logico
	// sotto il quale ci sono diverse commodity
	center_id: string;

	name: string;
	network_name: string;
	address: string;
	address_number: string;
	address_zone: string;
	municipality: string;
	province_code: string;
	location: string;
	region: string;
	zip_code: string;
	lat: string;
	lng: string;
	vat_number: string;
	fiscal_code: string;
	phone: string;
	email: string;
	flag_delivery_point: boolean;
	flag_return_point: boolean;
	flag_dedicated_expert: boolean;
	flag_premium_point: boolean;
	flag_base_ald: boolean;
	flag_service_box: boolean;
	flag_mobstore: boolean;
	flag_2w:boolean;
	created_at: string;
	updated_at: string;
	distance?: number;
	status: number;

	//app variable
	labelForDetails: string;
	labelForSelect: string;

	type_description: string;
	type_id: CommodityTypeId;

	isTyres: boolean;
	cod_axus: string;

	private labelForSelected: string;
	private labelForNotSelected: string;
	agreement: string

	constructor(model?: any) {
		if (model) {
			this.id = model.id;
			this.ald_commodity_id = model.ald_commodity_id;
			this.ald_supplier_id = model.ald_supplier_id;
			this.ald_supplier_code = model.ald_supplier_code;
			this.ald_parent_id = model.ald_parent_id;
			this.center_id = model.center_id;
			this.name = model.name;
			this.network_name = model.network_name;
			this.address = model.address;
			this.address_number = model.address_number;
			this.address_zone = model.address_zone;
			this.municipality = model.municipality;
			this.province_code = model.province_code;
			this.location = model.location;
			this.region = model.region;
			this.zip_code = model.zip_code;
			this.lat = model.lat;
			this.lng = model.lng;
			this.vat_number = model.vat_number;
			this.fiscal_code = model.fiscal_code;
			this.phone = model.phone;
			this.email = model.email;
			this.flag_delivery_point = model.flag_delivery_point;
			this.flag_return_point = model.flag_return_point;
			this.flag_dedicated_expert = model.flag_dedicated_expert;
			this.created_at = model.created_at;
			this.updated_at = model.updated_at;
			this.distance = model.distance;
			this.type_description = model.type_description;
			this.type_id = model.type_id;
			this.flag_premium_point = model.flag_premium_point;
			this.flag_base_ald = model.flag_base_ald;
			this.flag_mobstore=model.flag_mobstore;
			this.flag_service_box = model.flag_service_box;
			this.flag_2w=model.flag_2w;
			this.cod_axus = model.cod_axus;
			this.status = model.status;
			this.setLabels();
		}
	}

	public setLabels() {
		if (this.isTyres) {
			this.setLabelsTyres();
		} else {
			this.setLabelsAllModule();
		}
	}

	public setLabelsAllModule() {
		if (!Utilities.isVoid(this.address)) {
			this.labelForDetails = this.address;
			if (!Utilities.isVoid(this.address_number)) {
				this.labelForDetails += ', ' + this.address_number;
			}
		} else {
			this.labelForDetails = this.name;
		}

		this.labelForSelected = this.labelForDetails;

		if (this.labelForDetails !== this.name) {
			this.labelForNotSelected = this.name + ' - ' + this.labelForDetails;
		} else {
			this.labelForNotSelected = this.name;
		}

		this.setLabelForNotSelected();
	}

	/** NEMOGUI-651 */
	public setLabelsTyres() {
		if (this.ald_commodity_id === CommodityModel.allCentersID) {
			this.labelForSelected = this.name;
			this.labelForNotSelected = this.name;
		} else {
			if (!Utilities.isVoid(this.address)) {
				this.labelForSelected = this.address;
				if (!Utilities.isVoid(this.address_number)) {
					this.labelForSelected += ', ' + this.address_number;
				}
			}
			this.labelForNotSelected = this.network_name + ' - ' + this.labelForSelected;
		}

		this.setLabelForNotSelected();
	}

	setLabelForSelected() {
		this.labelForSelect = this.labelForSelected;
	}

	setLabelForNotSelected() {
		this.labelForSelect = this.labelForNotSelected;
	}

	getTotalAddress(): string {
		let name: string;
		if (!Utilities.isVoid(this.address)) {
			name = this.address;
			if (!Utilities.isVoid(this.address_number)) {
				name += ', ' + this.address_number;
			}
			if (!Utilities.isVoid(this.zip_code)) {
				name += ' - ' + this.zip_code;
			}
			if (!Utilities.isVoid(this.municipality)) {
				name += ' ' + this.municipality;
			}
		} else {
			name = '- - -';
		}
		return name;
	}

	setIsTyres(val: boolean) {
		this.isTyres = val;
	}
}
